import type { NumberRange } from "../../typings"
import { FilterModifier } from "./FilterModifier"

export const NullableNumberEqualsFilterModifier = FilterModifier.create<number | null, number | null>({
	id: "nullable-number-equals",
	getApplyFn: (filterValue) => (value) => {
		return value === filterValue
	},
	render: () => "is",
	serialize: (filterValue) => filterValue,
	deserialize: (filterValue) => filterValue,
})

export const NullableNumberNotEqualsFilterModifier = FilterModifier.create<number | null, number | null>({
	id: "nullable-number-not-equals",
	getApplyFn: (filterValue) => (value) => {
		return value !== filterValue
	},
	render: () => "is not",
	serialize: (filterValue) => filterValue,
	deserialize: (filterValue) => filterValue,
})

export const NumberEqualsFilterModifier = FilterModifier.create<number, number>({
	id: "number-equals",
	getApplyFn: (filterValue) => (value) => {
		return value === filterValue
	},
	render: () => "is",
	serialize: (filterValue) => filterValue,
	deserialize: (filterValue) => filterValue,
})

export const NumberNotEqualsFilterModifier = FilterModifier.create<number, number>({
	id: "number-not-equals",
	getApplyFn: (filterValue) => (value) => {
		return value !== filterValue
	},
	render: () => "is not",
	serialize: (filterValue) => filterValue,
	deserialize: (filterValue) => filterValue,
})

export const NumberLessThanFilterModifier = FilterModifier.create<number, number>({
	id: "number-less-than",
	getApplyFn: (filterValue) => (value) => {
		return value < filterValue
	},
	render: () => "is less than",
	serialize: (filterValue) => filterValue,
	deserialize: (filterValue) => filterValue,
})

export const NumberLessThanOrEqualsFilterModifier = FilterModifier.create<number, number>({
	id: "number-less-than-or-equals",
	getApplyFn: (filterValue) => (value) => {
		return value <= filterValue
	},
	render: () => "is less than or equal to",
	serialize: (filterValue) => filterValue,
	deserialize: (filterValue) => filterValue,
})

export const NumberGreaterThanFilterModifier = FilterModifier.create<number, number>({
	id: "number-greater-than",
	getApplyFn: (filterValue) => (value) => {
		return value > filterValue
	},
	render: () => "is greater than",
	serialize: (filterValue) => filterValue,
	deserialize: (filterValue) => filterValue,
})

export const NumberGreaterThanOrEqualsFilterModifier = FilterModifier.create<number, number>({
	id: "number-greater-than-or-equals",
	getApplyFn: (filterValue) => (value) => {
		return value >= filterValue
	},
	render: () => "is greater than or equal to",
	serialize: (filterValue) => filterValue,
	deserialize: (filterValue) => filterValue,
})

export const NumberRangeInFilterModifier = FilterModifier.create<number, NumberRange>({
	id: "number-range-in",
	getApplyFn: (filterValue) => (value) => {
		if (filterValue.to !== undefined && value > filterValue.to) return false
		if (filterValue.from !== undefined && value < filterValue.from) return false
		return true
	},
	render: () => "is between",
	serialize: (filterValue) => filterValue,
	deserialize: (filterValue) => filterValue,
})

export const NumberRangeNotInFilterModifier = FilterModifier.create<number, NumberRange>({
	id: "number-range-not-in",
	getApplyFn: (filterValue) => (value) => {
		if (filterValue.to !== undefined && value > filterValue.to) return true
		if (filterValue.from !== undefined && value < filterValue.from) return true
		return false
	},
	render: () => "is not between",
	serialize: (filterValue) => filterValue,
	deserialize: (filterValue) => filterValue,
})
